'use client'
import { Col, Icon, Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import React, { useState } from 'react'

export const AdvancedTradeTradingviewDialog = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { t } = useTranslate()
  const [open, setOpen] = useState(false)
  return (
    <Col className='w-full h-fit p-md rounded-t-lg shadow-md fixed bottom-0 left-0 right-0 z-50 bg-neutral-surface-light border border-neutral-surface-5'>
      <Row className='gap-xs' onClick={() => setOpen(!open)}>
        <Icon name={open ? 'ChevronDown' : 'ChevronUp'} size='xs' />
        <Typography size='xs' weight='bold'>
          {open ? t('chart_hide_chart') : t('chart_show_chart')}
        </Typography>
      </Row>
      {open && <div className='mt-md h-[80dvh]'>{children}</div>}
    </Col>
  )
}
